// @flow

import * as React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";

import { getProfile } from "../actions/user";
import { clearCart } from "../actions/cart";
import addACFData from "../utils/addACFData";
import getContentReferenceTileProps from "../utils/getContentReferenceTileProps";

import useInvertedNav from "../hooks/useInvertedNav";
import usePageFromStore from "../hooks/usePageFromStore";
import Config from "../constants/Config";
import { PrimaryNavPad } from "../components/organisms/PrimaryNav";
import HeroClubDetail from "../components/organisms/HeroClubDetail";
import ClubDetailBody from "../components/organisms/ClubDetailBody";
import RelatedContent from "../components/organisms/RelatedContent";
import QuickRegistrationBody from "../components/organisms/QuickRegistrationBody";
import Loader from "../components/atoms/Loader";
import Leaderboard from "../components/organisms/Leaderboard.js";

type PropsType = {
    page: any,
};

const ClubDetail = (props: PropsType): React.Node => {
    const { loggedIn, profile } = useSelector((state: any): any => state.user);
    // const { clubQuickRegistration } = useSelector(
    //     (state: any): any => state.cart
    // );
    const queryParams = queryString.parse(document.location.search);
    const [initialParams, setInitialParams] = React.useState(queryParams);
    const { page } = usePageFromStore();
    // const existingClubQuickReg =
    //     clubQuickRegistration && clubQuickRegistration.clubId;
    const hasMembership =
        profile && profile.active_memberships
            ? profile.active_memberships.filter(
                  memberships => memberships.club_id === page.ID
              ).length > 0
            : false;
    const userTypeClubProduct =
        profile && profile.type
            ? Array.isArray(page?.acf?.club_products) &&
              page?.acf?.club_products.find(clubProduct => {
                  return (
                      clubProduct.type.toLowerCase() ===
                      profile.type.toLowerCase()
                  );
              })
            : false;

    //Leaderboard
    const leaderboard = props.page.acf.bottom_leaderboard_ad
        ? getContentReferenceTileProps(
              addACFData(props.page.acf.bottom_leaderboard_ad)
          )
        : null;

    const [checkoutSuccessRedirectUrl] = React.useState(
        encodeURIComponent(
            `${document.location.pathname}${document.location.search}&checkout=success`
        )
    );

    const refreshParams = () => {
        const queryParams = queryString.parse(document.location.search);
        setInitialParams(queryParams);
    };

    // Hero ClubDetail
    const hero = page.acf.hero;

    // Events Content
    const events = page.upcoming_events;

    const categories = page.categories
        ? page.categories.map(category => category.term_id)
        : [];

    if (page.acf) {
        if (
            initialParams.quickRegistration === "true" &&
            initialParams.checkout === "success"
        ) {
            // club quick registration success page
            return (
                <QuickRegistrationBody
                    {...page}
                    checkout={true}
                    refreshParams={refreshParams}
                />
            );
        }

        if (initialParams.quickRegistration === "true") {
            if (
                loggedIn &&
                !hasMembership &&
                userTypeClubProduct &&
                // !existingClubQuickReg && // Logged in users should redirect to checkout even with ClubQuickReg
                page.acf.open_state === "open"
            ) {
                // logged in user who is returning with club quick registration state and is not already in the current club
                // add membership and push to cart
                return (
                    <QuickRegistrationCartRedirect
                        redirect={`${Config.routes.checkout}?addItem=${userTypeClubProduct.product.ID}&checkoutRedirectUrl=${checkoutSuccessRedirectUrl}`}
                    />
                );
            } else {
                // standard club quick registration page
                return (
                    <QuickRegistrationBody
                        {...page}
                        refreshParams={refreshParams}
                    />
                );
            }
        }

        return (
            <React.Fragment>
                {hero ? (
                    <HeroClubDetail
                        {...hero}
                        title={page.post_title}
                        breadcrumbs={Config.clubBreadcrumbs}
                    />
                ) : null}

                {events ? <ClubDetailBody {...page} events={events} /> : null}

                {/* Leaderboard */}
                {leaderboard && (
                    <Leaderboard
                        useContainer={true}
                        imageDesktop={leaderboard.image_desktop}
                        imageMobile={leaderboard.image_mobile}
                        alt={leaderboard.title}
                        link={leaderboard.url}
                        pageType="club"
                        position="bottom"
                    />
                )}

                {categories && categories.length > 0 ? (
                    <RelatedContent
                        title="Other clubs you might be interested in..."
                        useDynamicContent={true}
                        categories={categories}
                    />
                ) : null}
            </React.Fragment>
        );
    } else {
        return null;
    }
};

const QuickRegistrationCartRedirect = props => {
    const dispatch = useDispatch();
    const history = useHistory();

    useInvertedNav();

    React.useEffect(() => {
        dispatch(clearCart()).then(() => {
            history.replace(props.redirect);
        });
    }, []); //eslint-disable-line

    return (
        <>
            <PrimaryNavPad />

            <div className="login-profile-body container-fluid center-xs">
                <br />
                <br />
                <br />
                <br />
                <br />

                <Loader active={true} inline={true} fill={"#008731"} />
            </div>

            {/* <Redirect to={props.redirect} /> */}
        </>
    );
};

ClubDetail.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

ClubDetail.preload = ({ passed: { store }, location }: any): Promise<any> => {
    return Promise.all([
        store.dispatch(getProfile(true)),
        // store.dispatch(actions.fetchPage(location.pathname, location.search)),
    ]);
};

export default ClubDetail;
